export const KEYBOARD_EVENT_KEYS = {
  ESCAPE: 'Escape',
};
